import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Tool01 = function Tool01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M15.6314 7.6314c-.3961-.396-.5941-.594-.6683-.8224a1 1 0 0 1 0-.618c.0742-.2283.2722-.4264.6683-.8224l2.8383-2.8383C17.7165 2.1896 16.8804 2 16 2c-3.3137 0-6 2.6863-6 6 0 .491.059.9683.1702 1.425.1192.4892.1788.7338.1682.8883-.0111.1618-.0352.2479-.1098.3918-.0712.1375-.2078.274-.4808.5471L3.5 17.5c-.8284.8284-.8284 2.1716 0 3s2.1716.8284 3 0l6.2478-6.2478c.273-.2731.4096-.4096.5471-.4808.1439-.0746.23-.0987.3918-.1098.1545-.0106.399.049.8882.1681.4568.1113.934.1703 1.4251.1703 3.3137 0 6-2.6863 6-6 0-.8804-.1896-1.7165-.5303-2.4697l-2.8383 2.8383c-.3961.396-.5941.594-.8224.6682a1 1 0 0 1-.618 0c-.2284-.0741-.4264-.2721-.8224-.6682z"
    })
  }));
};
export default Tool01;